import lazyLoading from './lazyLoading';

export default {
  name: 'Enquiries',
  path: '/park/enquiries/:id?',
  component: lazyLoading('parkec/PARK_Enquiries'),
  meta: {
    title: 'schema.park_enquiries',
    iconClass: 'far fa-comment-alt',
    to: '/park/enquiries',
    auth: 'admin',
  },
  props: r => ({root: true, id: r.params.id}),
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/enquiries.js